<template>
   <div class="chart_control row col-md-12">
      <div class="col">
          <div class="h4 page-heading">
              {{title}}
          </div>
      </div>
      <div class="col text-right">
        <!-- <vk-button class="chart_button">Filter</vk-button> -->
        <!-- <vk-button>Export</vk-button> -->
        <vk-button class="chart_button" style="text-transform: capitalize;">Export</vk-button>
        <vk-dropdown style="min-width: 120px !important; text-align: left; cursor: pointer;">
          <vk-nav-dropdown> 
            <div><i class="fa fa-file-image-o fa-2x"  @click="exportDeviceList('image')"></i> Image</div>
            <div><i class="fa fa-file-pdf-o fa-2x" style="color: #f53;" @click="exportDeviceList('pdf')"></i> PDF</div>
            <div><i class="fa fa-file-excel-o fa-2x" style="color: #483;"  @click="exportDeviceList('csv')"></i> CSV</div>
            <div><i class="fa fa-file-word-o fa-2x"  style="color: #39f;" @click="exportDeviceList('doc')"></i> DOC</div>
          </vk-nav-dropdown>
        </vk-dropdown>
      </div>
</div>
</template>

<script>
/* eslint-disable */
var tableExport = require("table-export");
export default {
  name: "grey-table-header",
  props: ["title", "id"],
  data: function() {
    return {
      battery_meter: {
        background: "green",
        width: "50%"
      }
    };
  },
  components: {},
  methods: {
    exportDeviceList(type) {
      tableExport("device_list", this.title, type);
    }
  },
  mounted() {},
  updated() {}
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/kitchen/grey-table-header.vue